import { Injectable } from '@angular/core';
import * as Survey from "survey-angular";
import * as SurveyPDF from "survey-pdf";
import { CampConfigurationService } from './camp-configuration.service';
import { ICampModule } from '../model/camp-module.model';
import { getActiveSurveyJSModules } from '../util/surveyjs-utils';
import { replaceFrenchCharecterByHTMLCode, translateSurveyJS } from '../util/common-utils';
import { ICamp } from '../model/camp.model';
import { CampFichierCategorieEnum } from '../constant/enum';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DdcFichier } from '../model/camp-fichier.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FileReaderService } from './file-reader.service';
import { SurveyModel } from 'survey-core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class GenerateDossierCampService {

  public resourceUrl = environment.apiServerUrl + 'ddc-fichiers';

  pdfFooter: IBase64File = {base64: null};

  constructor(
    protected campConfigurationService: CampConfigurationService,
    protected fileReaderService: FileReaderService,
    protected http: HttpClient,
    protected sanitizer: DomSanitizer
  ) {
    this.initFooter();
  }

  survey: Survey.Model;

  initFooter(): void {
    // Apply theme
    // Survey.StylesManager.applyTheme('modern');

    // Load the footer of the pdf
    this.fileReaderService.getFileFromAssets('assets/img/ddc-pdf-footer.jpg', {responseType: 'blob'})
      .subscribe((pdfFooter: Blob) => {
          this.convertBlobToBase64(pdfFooter, this.pdfFooter);
        },
        (err) => {
          console.log('The error is the following ', err);
        });
  }

  convertBlobToBase64(blob: Blob, file: IBase64File) {
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      file.base64 = reader.result;
    }
  }

  // Render the footer of surveyjs pdf
  renderFooter(canvas) {
    canvas.drawImage({
      base64: this.pdfFooter && this.pdfFooter.base64 ? this.pdfFooter.base64.toString() : null,
      rect: {
        xLeft: 45,
        xRight: canvas.controller.paperWidth - 45,
        yTop: canvas.controller.paperHeight - 90,
        yBot: canvas.controller.paperHeight - 20
      },

    });
  }


  prepareSurveyJsPages(campConfigurationService: CampConfigurationService, campModule: ICampModule) {
    const surveyjsJson: ISurveyJSJson = translateSurveyJS(campConfigurationService, campModule.module.surveyjsJson);
    return surveyjsJson.pages;
  }

  printSurveyJSModules(camp: ICamp): Promise<DdcFichier> {
    let parser = new DOMParser();
    const campModules = getActiveSurveyJSModules(camp);
    let promises = [];
    let formData = new FormData();
    formData.append('idCamp', camp.id.toString());
    formData.append('categorie', CampFichierCategorieEnum.DOSSIER_CAMP);

    let counter = 0;

    if (campModules && campModules.length > 0) {
      const json = {pages:[]};
      let data = {};
      campModules.forEach((campModule: ICampModule) => {
        const surveyJsPages = this.prepareSurveyJsPages(this.campConfigurationService, campModule);
        if (surveyJsPages && surveyJsPages.length > 0) {
          surveyJsPages.forEach(surveyPage => {
            const elements = surveyPage['elements'];
            json.pages.push(surveyPage);
            data = {...data, ...campModule.surveyjsReponsesJson};
          })
        }
      });
        var surveyPdf = new SurveyPDF.SurveyPDF({});
        surveyPdf.mode = "display";
        surveyPdf.haveCommercialLicense = true;
        surveyPdf.options.fontSize = 12;
        surveyPdf.options.margins = {left: 17, right: 17, top: 17, bot: 35};
        surveyPdf.options.format = 'a4';
        surveyPdf.options.orientation = 'p';
        surveyPdf.onRenderFooter.add((_, canvas) => this.renderFooter(canvas));
        surveyPdf.showQuestionNumbers = 'off';
        surveyPdf.setJsonObject(json);
        surveyPdf.locale = 'fr';
        surveyPdf.onTextMarkdown.add((survey:SurveyModel, options) => {
          const body = parser.parseFromString(options.text, 'text/html').body;
          const str = body.innerHTML;
          let output = "";
          for (let i=0; i<str.length; i++) {
            if (str.charCodeAt(i) <= 127) {
              output += str.charAt(i);
            }else {
              output += replaceFrenchCharecterByHTMLCode(str.charAt(i));
            }
          }
          options.html = output;
        });
      surveyPdf.data = data;

        const surveyPdfPromise = surveyPdf.raw('blob');
        promises.push(surveyPdfPromise);
      // });
    }

    return new Promise<DdcFichier>((resolve, reject) => {
      Promise.all(promises).then(surveyJsPdfBlobs => {
        if (surveyJsPdfBlobs && surveyJsPdfBlobs.length > 0) {
          let counter = 1;
          surveyJsPdfBlobs.forEach(surveyJsBlob => {
            formData.append('file-' + counter, surveyJsBlob);
            counter++;
          });
        }

        this.generateDossierCamp(formData).subscribe((res: HttpResponse<DdcFichier>) => {
          resolve(res.body);
        });
      });
    })
  }

  generateDossierCamp(formData: FormData): Observable<HttpResponse<DdcFichier>> {
    return this.http.post<DdcFichier>(`${this.resourceUrl}/generate-dossier-camp`, formData, {observe: 'response'});
  }

}

interface ISurveyJSJson {
  pages?: object[];
}

interface IBase64File {
  base64: string | ArrayBuffer
}
